var exports = {
  "n": "x31de4314--e67ee3--proof",
  "K": "x31de4314--e67ee3--icon",
};

module.exports = exports;
